import type { Answers } from '@/redux/slider';
import { goToSosOvm } from '@/utils/ovm';
import { buildOvmClickoutUrl, fetchIustaOvmLink } from '@/utils/iusta-ovm-link';
import { store } from '@/redux/store';
import { ConfigSlice } from '@/redux/config';
import { GeneralSlice } from '@/redux/general';
import { ModalSlice } from '@/redux/modal';
import OvmLinkPendingMain from '@/modals/ovm-link-pending/ovm-link-pending-main';

/**
 * Single entry point every OVM CTA should call instead of goToSosOvm directly.
 *
 * For pages with useIustaOvmLink (currently only bussgeldcheck), the clickout URL is no longer
 * built from the old-CRM client secret — it's read straight off the lead's IUSTA Case (custom
 * field 24448), which IUSTA can take up to ~1 minute to generate. This does one immediate check;
 * if the link is already there, redirect happens instantly with no modal at all. If not, it opens
 * a "please wait" modal that keeps polling and redirects automatically once ready.
 *
 * For every other page, this is a transparent pass-through to the existing goToSosOvm behaviour.
 */
export const goToOvm = async (appendPoaToCTA: boolean, answersDirect: Answers): Promise<void> => {
  const useIustaOvmLink = ConfigSlice.selectors.useIustaOvmLink(store.getState());
  const clientSecretUrl = GeneralSlice.selectors.clientSecretUrl(store.getState());
  const leadId = GeneralSlice.selectors.leadId(store.getState());

  if (!useIustaOvmLink || !leadId) {
    goToSosOvm(appendPoaToCTA, clientSecretUrl, answersDirect);
    return;
  }

  const result = await fetchIustaOvmLink(leadId);
  if (result.ready && result.url) {
    window.location.href = buildOvmClickoutUrl(result.url, appendPoaToCTA, answersDirect);
    return;
  }

  store.dispatch(
    ModalSlice.actions.openModal({
      main: <OvmLinkPendingMain leadId={leadId} appendPoaToCTA={appendPoaToCTA} answeredSlides={answersDirect} />,
    }),
  );
};
